import { Languages } from "src/common/descriptions/types";
import { CashboxCategoriesDescriptions } from "./types";

const DescriptionsEnUs: CashboxCategoriesDescriptions = {
    TITLE: "Cashbox Categories",
    TABLE: {
        ACTION_BUTTON: "Create Category",
        SEARCH_PLACEHOLDER: "Search",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        NAME: "Name",
        DESCRIPTION: "Description",
        TYPE: "Type",
        ACTIONS: "Actions",
    },
    INCOME: "Income",
    OUTCOME: "Outcome",
}

const DescriptionsEsUs: CashboxCategoriesDescriptions = {
    TITLE: "Categorias de Caja",
    TABLE: {
        ACTION_BUTTON: "Crear Categoría",
        SEARCH_PLACEHOLDER: "Buscar",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        NAME: "Nombre",
        DESCRIPTION: "Descripción",
        TYPE: "Tipo",
        ACTIONS: "Acciones",
    },
    INCOME: "Ingreso",
    OUTCOME: "Salida",
}

export const cashboxCategoriesDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}
